// extracted by mini-css-extract-plugin
export default {"userCard":"UserCard_userCard__xJdT4","header":"UserCard_header__0gLU-","title":"UserCard_title__50VKc"};